/**
 * Projects API
 */

import type { Project } from '../types';
import { fetchApi } from './fetch';

export async function getProjects(): Promise<Project[]> {
  const data = await fetchApi<{ data: Project[]; total: number; limit: number; skip: number }>('/projects');
  return data.data;
}

export async function createProject(data: {
  name: string;
  color?: string;
}): Promise<Project> {
  return fetchApi<Project>('/projects', {
    method: 'POST',
    body: JSON.stringify(data),
  });
}
